export class SecretQuestion {
    id: number;
    name: string;
    sortOrder: number;
}


// WEBPACK FOOTER //
// ./src/app/models/secretQuestion.ts